import React from "react";
import {useTheme} from "@material-ui/core"
import MUIDataTable from "mui-datatables";
import useStyles from "./styles"

class DataTable extends React.Component{

    filter() {
        const func = this.props.filter
        if (func){
            return this.props.data.map(row => func(row))
        }
        return this.props.data
    }

    render() {
        const {onDelete, onEdit, classes, columns, options} = this.props
        return <MUIDataTable
                data={this.filter()}
                className={classes.tableWidget}
                columns={columns}
                options={{
                    download: false,
                    elevation: 0,
                    filter: false,
                    print: false,
                    viewColumns: false,
                    onRowsDelete: (state) => {
                        onDelete(state.data.map(item => this.props.data[item.dataIndex]))
                        return true
                    },
                    onRowClick: (_, rowMeta) => {
                        onEdit(this.props.data[rowMeta.dataIndex])
                    },
                    sortOrder: this.props.sortOrder,
                    ...options
                }}
            />
    }
}

export default (props) => {
    const classes = useStyles(useTheme())
    return <DataTable classes={classes} {...props}/>
}